import { render, staticRenderFns } from "./resolveNumber.vue?vue&type=template&id=2af966f0&scoped=true&"
import script from "./resolveNumber.vue?vue&type=script&lang=js&"
export * from "./resolveNumber.vue?vue&type=script&lang=js&"
import style0 from "./resolveNumber.vue?vue&type=style&index=0&id=2af966f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af966f0",
  null
  
)

export default component.exports